// extracted by mini-css-extract-plugin
export default {"content":"uM-z","lookName":"vM-z","shopTheLookContainer":"wM-z","productContainer":"xM-z","imageContainer":"yM-z","mainImage":"zM-z"};